module.exports = __webpack_public_path__ + "img/avatar.bd0eafbd.svg";